import { MiniSwiper } from 'global/components/swipers/MiniSwiper';
import { gEnums } from 'global/enums/globalEnums';
import _ from 'lodash';
import { createScheduleTypes } from 'projectSpecific/sports/cnr/reducers/CreateSportsReducer';
import { CreatePlayoffContext } from 'projectSpecific/sports/create/CreatePlayoff';
import CreateSectionDates from 'projectSpecific/sports/create/subs/CreateSectionDates';
import { useContext, useEffect, useMemo, useState } from 'react';
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { sidebarMenuTypes, sidebarSliderTypes } from '../../../../global/cnr/reducers/SidebarReducer';
import { uniqueKey } from '../../../../global/common/keys';
import { currentHelpers } from '../../../../global/redirection/current';
import SeasonMatchesProvider from '../../cnr/contexts/SeasonMatchesContext';
import MatchListSelected from './MatchListSelected';
import PlayoffBracket, { playoffBracketTypes } from './PlayoffBracket';
import usePageNavigation from 'global/cnr/contexts/useHelpers/usePageNavigation';

const PlayoffBrackets = (props) => {

  const { componentContexts, round, roundItem, tournamentType, asGrid } = props
  const { pools: pools_init } = round ?? {}

  const upn = usePageNavigation()

  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state } = createPlayoffContext ?? {}
  const { playoff_info } = createPlayoff_state ?? {}
  const { playoffDates_current } = playoff_info ?? {}
  const { currentCount, currentNeeded } = playoffDates_current ?? {}

  const _allowCalIcon = createPlayoff_state ? true : false

  const _poolCount = pools_init ? _.size(pools_init) : 0

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { storageItemPage } = paps_state ?? {}

  // componentContexts
  const { uiItemContext } = componentContexts ?? {}
  const { item_state } = uiItemContext ?? {}
  const { viewItem } = item_state ?? {}

  // const [swiper, setSwiper] = useState()

  const create_scheduleDates = () => <CreateSectionDates
    createScheduleType={createScheduleTypes.playoff}
    menuDisplayType={gEnums.menuDisplayTypes.menuButtons}
    noMid={true}
  />

  const getSlides = (pls) => {
    const items = pls.map((p, index) => (
      {
        key: p,
        content: selectedMatches(p),
        caption: getItemCaption(p)
      })
    )

    if (_allowCalIcon) {
      items.push({
        key: 'calendar',
        icon: currentCount === currentNeeded ? 'calendar check outline' : 'calendar outline',
        content: create_scheduleDates()
      })
    }

    return items
  }

  const handleMatchClick = (clickedItem, itemKey, modifyMode, opts, ddn, ddProps, ddGroupIndex) => {
    if (itemKey) upn.handleNav_item(clickedItem, itemKey, modifyMode, opts, ddn, ddProps, ddGroupIndex)
  }

  const getItemCaption = (p => {
    let _caption = p
    switch (p) {
      case 'roundOf32':
        _caption = 'R32'
        break;
      case 'roundOf16':
        _caption = 'R16'
        break;
      case 'quarterFinals':
        _caption = 'quarters'
        break;
      case 'semiFinals':
        _caption = 'semis'
        break;
      default:
      // nothing
    }
    return _.startCase(_caption)
  })


  const selectedMatches = (p) => {
    const pool = pools_init ? pools_init[p] : null
    const { matches, poolKey } = pool ?? {}
    const mss = <SeasonMatchesProvider
      poolMatches={matches}
      pools={pools_init}
      isTournament={true}
      viewItem={viewItem}
      handleMatchClick={handleMatchClick}
      tournamentType={tournamentType}
      forPlayoff={true}
      poolKey={p}
    >
      {!asGrid && <MatchListSelected key={uniqueKey('cts', 'mls')} />}
      {asGrid && <PlayoffBracket pool={pool} pools_init={pools_init} tournamentType={tournamentType} />}
    </SeasonMatchesProvider>

    return mss
  }

  // const getPoolz = () => {
  //   const _pools = []
  //   if (pools_init) {
  //     if (pools_init.roundOf32) { _pools.push(playoffBracketTypes.roundOf32) }
  //     if (pools_init.roundOf16) { _pools.push(playoffBracketTypes.roundOf16) }
  //     if (pools_init.quarterFinals) { _pools.push(playoffBracketTypes.quarterFinals) }
  //     if (pools_init.semiFinals) { _pools.push(playoffBracketTypes.semiFinals) }
  //     if (pools_init.finals) { _pools.push(playoffBracketTypes.finals) }
  //   }
  //   const _swipeItems = getSlides(_pools)
  //   const _keyAs = 'pools'
  //   const _storageKey = 'ms_' + _keyAs
  //   const si = currentHelpers.getStorageItem(_storageKey, _pools, storageItemPage)
  //   const _currents = { pools: { index: si.index, item: si } }
  //   const _initProps = { sidebarSliderType: sidebarSliderTypes.labeled }
  //   const _sidebarItems = { smt: sidebarMenuTypes.two, items: _pools, selected: _currents.pools, keyAs: _keyAs, ..._initProps }
  //   setSwiper({ swipeItems: _swipeItems, sidebarItems: _sidebarItems })
  // }

  const swiper = useMemo(() => {
    const _pools = []
    if (pools_init) {
      if (pools_init.roundOf32) { _pools.push(playoffBracketTypes.roundOf32) }
      if (pools_init.roundOf16) { _pools.push(playoffBracketTypes.roundOf16) }
      if (pools_init.quarterFinals) { _pools.push(playoffBracketTypes.quarterFinals) }
      if (pools_init.semiFinals) { _pools.push(playoffBracketTypes.semiFinals) }
      if (pools_init.finals) { _pools.push(playoffBracketTypes.finals) }
    }
    const _swipeItems = getSlides(_pools)
    const _keyAs = 'pools'
    const _storageKey = 'ms_' + _keyAs
    const si = currentHelpers.getStorageItem(_storageKey, _pools, storageItemPage)
    const _currents = { pools: { index: si.index, item: si } }
    const _initProps = { sidebarSliderType: sidebarSliderTypes.labeled }
    const _sidebarItems = { smt: sidebarMenuTypes.two, items: _pools, selected: _currents.pools, keyAs: _keyAs, ..._initProps }
    return { swipeItems: _swipeItems, sidebarItems: _sidebarItems }
    // setSwiper({ swipeItems: _swipeItems, sidebarItems: _sidebarItems })
  }, [_poolCount, round, roundItem, pools_init, JSON.stringify(round)])

  // useEffect(() => {
  // if (pools_init) {
  // getPoolz()
  // }
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  // }, [_poolCount, round, roundItem, pools_init, JSON.stringify(round)]);




  return swiper ? <MiniSwiper swipeItems={swiper?.swipeItems} /> : <div>???</div>

}

export default PlayoffBrackets